import React from 'react';

import {
  IonPage,
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonBackButton,
  IonButtons,
} from '@ionic/react';

import styles from './Registration.module.css';
import RegistrationForm from '../components/RegistrationForm';
import { RouterProps } from 'react-router';

const Registration = ({ history }: RouterProps) => {
  const onCancelRegistration = () => {
    history.goBack();
  };

  const onSuccessfulRegistration = () => {
    history.push('/home');
  };
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Register Account</IonTitle>
          <IonButtons slot="start">
            <IonBackButton />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className={styles.container}>
          <RegistrationForm
            cancelRegistration={onCancelRegistration}
            successfulRegistration={onSuccessfulRegistration}
          />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Registration;
